import React from 'react';
import { Button } from 'antd';
import useDownloadVisualSeoAnalysisPdf from '../../reportRenderEngine/hooks/useDownloadVisualSeoAnalysisPdf';

type Props = {
    wGuid: string;
    url: string;
    disabled: boolean;
};

export default function DownloadPdfButton({ wGuid, url, disabled }: Props) {
    const { downloadPdf, isDownloadingPdf } = useDownloadVisualSeoAnalysisPdf();

    return (
        <Button
            className="download-pdf-button"
            size="small"
            disabled={disabled || isDownloadingPdf}
            icon={isDownloadingPdf ? 'loading' : 'file-pdf'}
            onClick={() => downloadPdf(wGuid, url)}
        >
            Download PDF
        </Button>
    );
}
